<div class="wrapper">
    <div class="heading">
        <img src="../../../../assets/images/icons/icon-client.svg" class="icon">
        <div class="text">Client not matched</div>
    </div>
    <ng-container *ngIf="user">
        <div class="phone">{{ user.phone }}</div>
    </ng-container>
</div>
